import React, { useEffect } from 'react'

export default function AdminFormModal({ open, title, description, children, onClose, onSubmit, submitLabel = '저장', size = 'medium', submitTone = 'primary' }) {
  useEffect(() => {
    if (!open) return undefined
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.()
    }
    document.addEventListener('keydown', onKeyDown)
    const previous = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKeyDown)
      document.body.style.overflow = previous
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="admin-modal-layer" role="presentation" onMouseDown={(event) => {
      if (event.target === event.currentTarget) onClose?.()
    }}>
      <form className={`admin-modal admin-modal-${size}`} onSubmit={onSubmit}>
        <header className="admin-modal-header">
          <div>
            <h2>{title}</h2>
            {description && <p>{description}</p>}
          </div>
          <button type="button" className="admin-modal-close" aria-label="닫기" onClick={onClose}>×</button>
        </header>
        <div className="admin-modal-body">{children}</div>
        <footer className="admin-modal-footer">
          <button type="button" className="button soft" onClick={onClose}>취소</button>
          <button type="submit" className={`button ${submitTone}`}>{submitLabel}</button>
        </footer>
      </form>
    </div>
  )
}

export function FormField({ label, required, hint, children, wide = false }) {
  return (
    <label className={`admin-form-field${wide ? ' is-wide' : ''}`}>
      <span>{label}{required && <b> *</b>}</span>
      {children}
      {hint && <small>{hint}</small>}
    </label>
  )
}

export function FormGrid({ children }) {
  return <div className="admin-form-grid">{children}</div>
}
